// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Navigate } from 'react-router';
import { IliquidAssets } from './iliquid-assets';
import { selectClient, selectClientId } from '@shared/data-access/slices/clients';
import { selectUserId } from '@shared/data-access/slices/user';
import { isAdvisorApp, isClientApp } from '@shared/environment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isDefined } from '@shared/utils';
import { type FC } from 'react';

export const IlliquidAssetsLayout: FC = () => {
  const clientId = useSelector(selectClientId);

  const client = useSelector(selectClient);

  const advisorUserId = useSelector(selectUserId);

  const canAccessIlliquidAssets = useMemo(() => {
    if (clientId === null) return false;

    if (isClientApp) return true;

    return isDefined(advisorUserId) && client?.citec_user_id === advisorUserId;
  }, [advisorUserId, client, clientId]);

  if (clientId === null) {
    return isAdvisorApp ? <Navigate to="/" replace /> : null;
  }

  if (!canAccessIlliquidAssets) {
    return <Navigate to="/aggregation" replace />;
  }

  return <IliquidAssets clientId={clientId} />;
};
